<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.audit') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.audit') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    ref="dateRange">
                  </el-date-picker>
              </div>
              <h4>
                <el-tooltip :content="$t('salary.export')" placement="top">
                  <el-button type="text" class="el-icon-download" @click="exportExcel"></el-button>
                </el-tooltip>
                <el-tooltip :content="$t('dashboard.refresh')" placement="top">
                  <el-button type="text" class="el-icon-refresh" @click="refreshData"></el-button>
                </el-tooltip>
              </h4>
            </div>
            <div class="card-body">
              <el-table
              id="audit-sheet"
                ref="audit"
                :data="data"
                style="width: 100%"
                @cell-click="showDetail"
                >
                <el-table-column
                  prop="name"
                  :label="$t('dashboard.behavior-audit.user')"
                  width="130"
                  align="center"
                  sortable
                  fixed>
                </el-table-column>
                <el-table-column
                  prop="team"
                  :label="$t('dashboard.behavior-audit.team')"
                  width="140"
                  align="center"
                  sortable
                  :filters="teamFilters"
                    :filter-method="filterTeam"
                  >
                  <template slot-scope="scope">
                    {{ getTeam(scope.row.team) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="practiceId"
                  :label="$t('dashboard.behavior-audit.practice')"
                  width="140"
                  align="center"
                  sortable
                  :filters="practiceFilters"
                    :filter-method="filterPractice"
                  >
                  <template slot-scope="scope">
                    {{ getPractice(scope.row.practiceId) }}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('dashboard.behavior-audit.comment')"
                  align="center">
                    <el-table-column
                      prop="comment.short.num"
                      :label="$t('dashboard.behavior-audit.too-short')"
                      width="100"
                      sortable
                      align="center">
                      <template slot-scope="scope">
                        {{ scope.row.comment.short.num }} / {{ scope.row.totalComments }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="comment.duplicated.num"
                      :label="$t('dashboard.behavior-audit.duplicate')"
                      width="100"
                      sortable
                      align="center">
                      <template slot-scope="scope">
                        {{ scope.row.comment.duplicated.num }} / {{ scope.row.totalComments }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="comment.interval.num"
                      :label="$t('dashboard.behavior-audit.interval')"
                      width="100"
                      sortable
                      align="center">
                    </el-table-column>
                </el-table-column>
                <el-table-column
                  :label="$t('dashboard.behavior-audit.lr')"
                  align="center">
                    <el-table-column
                      prop="leaveReason.short.num"
                      :label="$t('dashboard.behavior-audit.too-short')"
                      width="100"
                      sortable
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="leaveReason.duplicated.num"
                      :label="$t('dashboard.behavior-audit.duplicate')"
                      width="100"
                      sortable
                      align="center">
                    </el-table-column>
                    
                </el-table-column>
                <el-table-column
                  :label="$t('dashboard.behavior-audit.salary')"
                  align="center">
                    <el-table-column
                      prop="salaryDetail.short.num"
                      :label="$t('dashboard.behavior-audit.too-short')"
                      width="100"
                      sortable
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="salaryDetail.duplicated.num"
                      :label="$t('dashboard.behavior-audit.duplicate')"
                      width="100"
                      sortable
                      align="center">
                    </el-table-column>
                    
                </el-table-column>
               </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <el-dialog :title="$t('dashboard.behavior-audit.detail') + ' of ' + (currentData != null ? currentData.name : '')" 
      :visible.sync="showDetailModal"
      width="90%"
      top="30px"
      :append-to-body="true">
            <AuditDetail :data="currentData" />
            <div slot="footer" class="dialog-footer">
          <el-button @click="showDetailModal = false">{{ $t('profile.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
<script>
import moment from 'moment'
import { Loading } from 'element-ui'
import AuditDetail from '@/components/profile/AuditDetail.vue'

export default {
  name: 'Audit',
  data: function() {
  return {
    data: null,
    dateRange: [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')],
    showDetailModal: false,
    currentData: null
  }
  },
  components: {
    AuditDetail
  },
  computed: {
    teamFilters: function() {
    let filter = this.team,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
  },
  practiceFilters: function() {
    let filter = this.practice,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
  }
  },
  watch: {
    dateRange: function(val) {
      this.loadData()
    }
  },
  methods: {
    refreshData: function() {
      this.loadData()
    },
    showDetail: function(row, column, cell, event) {
      //console.log(row)
      //console.log(column)
      this.currentData = row
      this.showDetailModal = true
    },
    filterTeam: function(value, row) {
      return row.team === value
    },
    filterPractice: function(value, row) {
      return row.practice === value
    },
    exportExcel () {
      let wb = XLSX.utils.table_to_book(document.querySelector('#common-report'))
      /* get binary string as output */
      let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-User-Audit.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined')
          console.log(e, wbout)
      }
      return wbout
    },
    loadData: function() {
      let startDate = this.dateRange[0],
          endDate = this.dateRange[1],
          query = '?userId=' + localStorage.getItem('token') + '&startDate=' + startDate + '&endDate=' + endDate,
          that = this,
          loading = Loading.service({ fullscreen: true })
    this.$http.get(this.API3_PREFIX + 'behavior_audit' + query).then(function (response) {
    that.data = response.data
    that.$nextTick(() => {
          loading.close()
        })
      }).catch(function (error) {
    console.log(error)
    that.$nextTick(() => {
          loading.close()
        })
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>